import * as React from "react";
import styled from "styled-components";
import { GetShowBoothQuery } from "API";
import MainLogo from "components/atoms/MainLogo";

const BrandLogoCollection = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  max-width: 740px;
  widht: 100%;
  margin-left: auto;
  margin-right: auto;
`;

type Props = {
  booths: GetShowBoothQuery["getShowBooth"][];
  onClick: (item: any) => void;
};

type Logo = {
  id: string;
  photID: string;
  booth?: GetShowBoothQuery["getShowBooth"];
};

export default function BrandLogo(props: Props) {
  const { booths, onClick } = props;
  const [logos, setLogos] = React.useState<Logo[]>([]);

  React.useEffect(() => {
    function f() {
      const array = [] as Logo[];
      booths.forEach((booth) => {
        if (
          booth &&
          booth.brandLogos &&
          booth.brandLogos.phots &&
          booth.brandLogos.phots.items
        ) {
          booth.brandLogos.phots.items.forEach((item: any) => {
            const newLogo = {
              id: "",
              photID: "",
            } as Logo;
            if (item) {
              newLogo.photID = item.photID;
              newLogo.id = booth.id;
              newLogo.booth = booth;
              array.push(newLogo);
            }
          });
        }
      });
      setLogos(array);
    }
    f();
  }, [booths]);

  return (
    <BrandLogoCollection>
      {logos.map((logo) => (
        <MainLogo logo={logo} onClick={() => onClick(logo)} />
      ))}
    </BrandLogoCollection>
  );
}
